import { WidgetWrapper } from '@agentselly/ui';

interface Props {
  readonly title: string;
}

export function PartnerTitleWidget(props: Props) {
  // TODO: Implement this

  return (
    <WidgetWrapper>
      <h1 className="font-bold">{props.title}</h1>
    </WidgetWrapper>
  );
}
